'use client'

import { dataTestIds } from 'pdp/src/constants/dataTestIds/dataTestIds'
import { useColors } from 'pdp/src/contexts/ColorsProvider/ColorsProvider'
import type { CommonProps } from 'pdp/src/types/CommonProps'
import { ProductLocations } from 'product/types/ProductLocations'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import { ColorList } from './ColorList/ColorList'
import { SheetColorsSelector } from './SheetColorsSelector/SheetColorsSelector'

import styles from './ColorsSelector.module.scss'

export type ColorsSelectorProps = Pick<CommonProps, 'product' | 'look'>

export const REDUCED_COLOR_LIST_MAX_LENGTH = 4

export function ColorsSelector({
	product,
	look,
}: Readonly<ColorsSelectorProps>): React.ReactNode {
	const { colors, selectedColor } = useColors()
	const { availableScreenSize, isLessThanLarge } = useResponsive()

	const showMoreButton: boolean =
		availableScreenSize &&
		isLessThanLarge &&
		colors.length > REDUCED_COLOR_LIST_MAX_LENGTH

	return (
		<div
			className={styles.colorsSelector}
			data-testid={dataTestIds['pdp.productInfo.colorSelector']}
		>
			<div className={styles.list}>
				<ColorList
					product={product}
					look={look}
					priority
					location={ProductLocations.ColorSelector}
					data-testid={dataTestIds['pdp.productInfo.colorSelector.colorList']}
				/>
				{showMoreButton && (
					<SheetColorsSelector product={product} look={look} />
				)}
			</div>
			<p
				className={styles.label}
				aria-hidden
				data-testid={dataTestIds['pdp.productInfo.colorSelector.label']}
			>
				{selectedColor.label}
			</p>
		</div>
	)
}
